<template>
  <div @keyup.13="submit">
    <mu-dialog
      title="编辑订单"
      width="500"
      :open="open"
      @close="close"
      class="update-dialog"
    >
      <mu-form :model="editForm" label-position="left" label-width="100">
        <mu-form-item prop="orderId" label="订单号">
          <mu-text-field v-model="editForm.orderId"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="customer" label="客户">
          <mu-text-field v-model="editForm.customer"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="clerk" label="业务员">
          <mu-text-field v-model="editForm.clerk"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="sum" label="总金额">
          <mu-text-field v-model="editForm.sum"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="paid" label="已付金额">
          <mu-text-field v-model="editForm.paid"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="cadFile" label="CAD文件路径">
          <mu-text-field v-model="editForm.cadFile"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="cadFileName" label="CAD文件名">
          <mu-text-field v-model="editForm.cadFileName"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="remark" label="备注">
          <mu-text-field v-model="editForm.remark"></mu-text-field>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    form: {
      type: Object
    }
  },
  data() {
    return {
      editForm: {}
    }
  },
  methods: {
    submit() {
      backend(api.order.update, this.editForm).then((result) => {
        if (result.statusCode === 200) {
          this.close()
          this.$emit('finish')
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.editForm = JSON.parse(JSON.stringify(this.form))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.update-dialog {
}
</style>



// WEBPACK FOOTER //
// src/views/order/update.vue